<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Elementi Commessa </v-toolbar-title>

      <v-spacer></v-spacer>

      <!-- Bottone di aggiunta componente -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="aggiungiElemento"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus </v-icon>
          </v-btn>
        </template>
        <span>Nuovo Elemento</span>
      </v-tooltip>

      <!-- Bottone di aggiunta multipla -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="clickInserisciElementiMultipli"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="primary"> mdi-plus-box-multiple </v-icon>
          </v-btn>
        </template>
        <span>Aggiunta Elementi Multipli</span>
      </v-tooltip>

      <!-- Bottone di salvataggio -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="salvaElementi" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva Elementi</span>
      </v-tooltip>

      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card-text>
      <v-data-table
        dense
        :headers="headers_elementi"
        :items="items_elementi.filter((e) => e.validita == 1)"
      >
        <!-- Colonna del bottone di modifica -->
        <template v-slot:[`item.modifica`]="{ item }">
          <v-btn @click="modificaElemento(item)" small>
            <v-icon color="primary">mdi-pencil</v-icon>
          </v-btn>
        </template>

        <!-- Colonna della descrizione -->
        <template v-slot:[`item.des_articolo`]="{ item }">
          <v-text-field
            dense
            hide-details
            style="border-radius: 0px"
            v-model="item.des_articolo"
          ></v-text-field>
        </template>

        <!-- Colonna dell'eliminazione -->
        <template v-slot:[`item.elimina`]="{ item }">
          <v-btn @click="clickEliminaElemento(item)" small>
            <v-icon color="error">mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Dialog di modifica elemento -->
    <v-dialog v-model="dialog_edit_elemento" width="700px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Elemento di Commessa
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di salvataggio del singolo elemento -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="salvaModificaElemento"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_edit_elemento = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" justify="center">
              <v-col justify="center" cols="12">
                <!-- Tabella degli elementi nuovi -->
                <v-data-table
                  :headers="headers_aggiunta_elementi"
                  :items="elementi_sel"
                  hide-default-header
                  :hide-default-footer="
                    elementi_sel.filter((e) => e.validita == 1).length < 2
                  "
                >
                  <!-- Colonna del numero elemento -->
                  <template v-slot:[`item.num_elemento_display`]="{ item }">
                    <v-text-field
                      dense
                      hide-details
                      label="Num. Elemento"
                      outlined
                      readonly
                      style="border-radius: 0px"
                      v-model="item.num_elemento_display"
                    ></v-text-field>
                  </template>

                  <!-- Colonna della des_articolo -->
                  <template v-slot:[`item.des_articolo`]="{ item }">
                    <v-text-field
                      dense
                      hide-details
                      label="Descrizione"
                      outlined
                      style="border-radius: 0px"
                      v-model="item.des_articolo"
                    >
                      <template v-slot:prepend>
                        <v-icon
                          @click="openArticoliDialog(item)"
                          color="primary"
                        >
                          mdi-magnify
                        </v-icon>
                      </template>
                      <template v-slot:append-outer>
                        <v-icon
                          @click="deleteDesElemento(item)"
                          color="error"
                          v-if="
                            item.des_articolo != null ||
                            item.id_articolo != null
                          "
                        >
                          mdi-close
                        </v-icon>
                      </template>
                    </v-text-field>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di modifica elemento -->
    <v-dialog v-model="dialog_articoli" width="500px">
      <v-card>
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Articoli </v-toolbar-title>

          <v-spacer></v-spacer>

          <!-- Bottone di ricerca -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="mr-5"
                @click="searchArticoli"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="primary"> mdi-magnify </v-icon>
              </v-btn>
            </template>
            <span>Cerca</span>
          </v-tooltip>

          <!-- Bottone di salvataggio degli articoli -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="selezionaArticoli" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_articoli = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="pt-5" style="overflow-y: auto">
          <v-container fluid>
            <v-row align="center" dense justify="center">
              <v-col align="center" class="my-0 py-0" justify="center" cols="6">
                <!-- Filtro descrizione articolo -->
                <v-text-field
                  dense
                  hide-details
                  @keydown.enter="searchArticoli"
                  label="Des. Articolo"
                  outlined
                  style="border-radius: 0px"
                  v-model="des_articolo_search"
                >
                  <template v-slot:append-outer>
                    <v-icon
                      @click="des_articolo_search = null"
                      color="error"
                      v-if="
                        des_articolo_search != null && des_articolo_search != ''
                      "
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>

              <!-- Filtro codice articolo -->
              <v-col align="center" class="my-0 py-0" justify="center" cols="6">
                <v-text-field
                  dense
                  hide-details
                  @keydown.enter="searchArticoli"
                  label="Cod. Articolo"
                  outlined
                  style="border-radius: 0px"
                  v-model="cod_articolo_search"
                >
                  <template v-slot:append-outer>
                    <v-icon
                      @click="cod_articolo_search = null"
                      color="error"
                      v-if="
                        cod_articolo_search != null && cod_articolo_search != ''
                      "
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row align="center" dense justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-data-table
                  class="mt-5"
                  dense
                  :headers="headers_articoli"
                  :items="items_articoli"
                >
                  <!-- Colonna della selezione -->
                  <template v-slot:[`item.selezione`]="{ item }">
                    <v-simple-checkbox color="primary" v-model="item.selezione">
                    </v-simple-checkbox>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>

      <v-overlay :value="overlay_articoli" style="z-index: 10">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-dialog>

    <!-- Dialog di input per la quantità nuovi elementi -->
    <v-dialog v-model="dialog_qta_elementi_multipli" width="500">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Quantità Elementi
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="inserisciElementiMultipli"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Aggiungi</span>
          </v-tooltip>

          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_qta_elementi_multipli = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <v-container>
            <v-row align="center" class="mb-5" justify="center">
              <span style="color: rgb(0, 0, 0); font-size: 18px">
                Quanti elementi vuoi aggiungere?
              </span>
            </v-row>
            <v-row align="center" justify="center">
              <v-col align="center" class="my-0 py-0" justify="center" cols="6">
                <v-text-field
                  dense
                  hide-details
                  outlined
                  style="border-radius: 0px; max-width: 100px"
                  v-model.number="qta_elementi_multipli"
                  type="number"
                ></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-select
                  dense
                  hide-details
                  :items="items_stile_descrizione"
                  item-text="text"
                  item-value="value"
                  label="Descrizione"
                  outlined
                  style="border-radius: 0px"
                  v-model="stile_descrizione"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma eliminazione dei elemento -->
    <v-dialog v-model="dialog_conferma_eliminazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Eliminazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Confermi di voler eliminare l'elemento selezionato?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn
                  class="mr-5"
                  @click="dialog_conferma_eliminazione = false"
                  small
                >
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>

                <v-btn @click="eliminaElemento" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

class Elemento {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] =
          arg[c.nome] != undefined
            ? c.complex === false
              ? arg[c.nome]
              : JSON.parse(JSON.stringify(arg[c.nome]))
            : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_commessa_elemento", complex: false, default_val: null },
      { nome: "id_commessa", complex: false, default_val: null },
      { nome: "num_elemento", complex: false, default_val: null },
      { nome: "num_elemento_display", complex: false, default_val: null },
      { nome: "id_articolo", complex: false, default_val: null },
      { nome: "des_articolo", complex: false, default_val: null },
      { nome: "validita", complex: false, default_val: 1 },
    ];

    return campi;
  }
}

export default {
  name: "CommessaElementi",
  components: { SnackbarQV },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      cod_articolo_search: null,
      des_articolo_search: null,
      elemento_sel_delete: new Elemento(),
      idx_elemento_sel: 0,
      qta_elementi_multipli: 2,
      stile_descrizione: null,

      // Modal
      dialog_articoli: false,
      dialog_conferma_eliminazione: false,
      dialog_edit_elemento: false,
      dialog_qta_elementi_multipli: false,
      overlay: false,
      overlay_articoli: false,

      // Array
      elementi_sel: new Array(),
      headers_articoli: [
        {
          value: "selezione",
          text: "Selezione",
          sortable: false,
          width: "100px",
        },
        {
          value: "cod_articolo",
          text: "Cod. Articolo",
          sortable: false,
        },
        {
          value: "des_articolo",
          text: "Des. Articolo",
          sortable: false,
        },
      ],
      headers_aggiunta_elementi: [
        {
          value: "num_elemento_display",
          text: "",
          sortable: false,
        },
        {
          value: "des_articolo",
          text: "",
          sortable: false,
        },
      ],
      headers_elementi: [
        {
          value: "modifica",
          text: "Modifica",
          sortable: false,
          width: "100px",
        },
        {
          value: "num_elemento_display",
          text: "Num. Elemento",
          sortable: false,
          width: "200px",
        },
        {
          value: "des_articolo",
          text: "Descrizione",
          sortable: false,
        },
        {
          value: "elimina",
          text: "Elimina",
          sortable: false,
          width: "100px",
        },
      ],
      items_articoli: new Array(),
      items_elementi: new Array(),
      items_stile_descrizione: [
        { value: 1, text: "Letterale crescente" },
        { value: 2, text: "Libera" },
      ],
      lettere_alfabeto: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z",
      ],
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    aggiungiElemento() {
      this.elementi_sel = new Array();
      const elemento_tmp = new Elemento();
      elemento_tmp.id_commessa_elemento = this.assegnaIdCommessaElemento();
      elemento_tmp.num_elemento = this.assegnaNumElemento("no_selezionati");
      elemento_tmp.id_commessa = this.$route.params.id;
      elemento_tmp.num_elemento_display = `E${elemento_tmp.num_elemento}`;
      this.elementi_sel.push(elemento_tmp);
      this.dialog_edit_elemento = true;
    },
    assegnaIdCommessaElemento() {
      let id_tmp = -1;
      this.items_elementi
        .filter((e) => e.validita == 1)
        .forEach((e) => {
          if (e.id_commessa_elemento <= id_tmp) {
            id_tmp = e.id_commessa_elemento - 1;
          }
        });
      this.elementi_sel
        .filter((e) => e.validita == 1)
        .forEach((e) => {
          if (e.id_commessa_elemento <= id_tmp) {
            id_tmp = e.id_commessa_elemento - 1;
          }
        });
      return id_tmp;
    },
    assegnaLetteraAlfabetica() {
      // Parto dall'indice iniziale.
      let next_index_lettera = 0;

      /* Controllo se l'ultimo elemento degli elementi già
       * aggiunti usa un indice e prendo l'indice successivo. */
      this.items_elementi.forEach((elem) => {
        next_index_lettera =
          this.lettere_alfabeto.indexOf(elem.des_articolo) > -1
            ? this.lettere_alfabeto.indexOf(elem.des_articolo) + 1
            : next_index_lettera;
      });

      /* Controllo se l'ultimo elemento degli elementi da
       * aggiungere usa un indice e prendo l'indice successivo */
      this.elementi_sel.forEach((elem) => {
        next_index_lettera =
          this.lettere_alfabeto.indexOf(elem.des_articolo) > -1
            ? this.lettere_alfabeto.indexOf(elem.des_articolo) + 1
            : next_index_lettera;
      });

      // Se ho finito l'alfabeto, ricomincio daccapo.
      next_index_lettera =
        next_index_lettera > this.lettere_alfabeto.length - 1
          ? 0
          : next_index_lettera;

      // Ritorno l'indice.
      return this.lettere_alfabeto[next_index_lettera];
    },
    assegnaNumElemento(arg_selezionati) {
      let num_tmp =
        this.items_elementi.filter((e) => e.validita == 1).length + 1;

      this.items_elementi
        .filter((e) => e.validita == 1)
        .forEach((e) => {
          if (e.num_elemento >= num_tmp) {
            num_tmp = e.num_elemento + 1;
          }
        });

      /* Valuto se tenere conto anche degli elementi
       * che devono ancora essere aggiunti. */
      if (arg_selezionati == "selezionati") {
        this.elementi_sel
          .filter((e) => e.validita == 1)
          .forEach((e) => {
            if (e.num_elemento != null && e.num_elemento >= num_tmp) {
              num_tmp = e.num_elemento + 1;
            }
          });
      }

      return num_tmp;
    },
    clickEliminaElemento(arg) {
      this.elemento_sel_delete = new Elemento(arg);
      this.dialog_conferma_eliminazione = true;
    },
    clickInserisciElementiMultipli() {
      this.elementi_sel = new Array();

      this.qta_elementi_multipli = 2;
      this.stile_descrizione = null;
      this.dialog_qta_elementi_multipli = true;
    },
    deleteDesElemento(arg) {
      this.$set(arg, "des_articolo", null);
      this.$set(arg, "id_articolo", null);
    },
    eliminaElemento() {
      this.items_elementi.forEach((e) => {
        if (
          e.id_commessa_elemento ==
          this.elemento_sel_delete.id_commessa_elemento
        ) {
          e.validita = 0;
        }
      });
      this.dialog_conferma_eliminazione = false;
    },
    getElementi() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getcommessaelementi",
          token: localStorage.user_token,
          id_commessa: this.$route.params.id,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.items_elementi = new Array();

            /* Per ogni oggetto che il BE mi manda, gli aggiungo il
             * num_elemento_display che deve essere visualizzato in FE. */
            res.data.result.elementi.forEach((e) => {
              const obj_tmp = new Elemento(e);
              obj_tmp.num_elemento_display = `E${e.num_elemento}`;
              this.items_elementi.push(obj_tmp);
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    inserisciElementiMultipli() {
      // Controllo la validità della quantità.
      if (
        this.qta_elementi_multipli == null ||
        this.qta_elementi_multipli === "" ||
        this.qta_elementi_multipli <= 0
      ) {
        this.$refs.SnackbarQV.print("orange", "Quantità non conforme.");
        return;
      }

      for (let i = 0; i < this.qta_elementi_multipli; i++) {
        const elemento_tmp = new Elemento();
        elemento_tmp.id_commessa_elemento = this.assegnaIdCommessaElemento();
        elemento_tmp.num_elemento = this.assegnaNumElemento("selezionati");
        elemento_tmp.id_commessa = this.$route.params.id;
        elemento_tmp.num_elemento_display = `E${elemento_tmp.num_elemento}`;

        if (this.stile_descrizione == 1) {
          elemento_tmp.des_articolo = this.assegnaLetteraAlfabetica();
        }

        this.elementi_sel.push(elemento_tmp);
      }

      this.dialog_qta_elementi_multipli = false;

      /* Se lo stile descrizione è automatico, metto
       * direttamente gli elementi nella lista per il
       * salvataggio; altrimenti li metto nella lista di
       * modifica e sarà l'utente ad assegnare le descrizioni. */
      if (this.stile_descrizione == 1) {
        this.salvaModificaElemento();
      } else {
        this.dialog_edit_elemento = true;
      }
    },
    modificaElemento(arg) {
      const elemento_tmp = new Elemento(arg);
      this.elementi_sel = new Array();
      this.elementi_sel.push(elemento_tmp);
      this.dialog_edit_elemento = true;
    },
    openArticoliDialog(arg) {
      this.elementi_sel.forEach((e, i) => {
        if (e.id_commessa_elemento == arg.id_commessa_elemento) {
          this.idx_elemento_sel = i;
        }
      });

      this.items_articoli = new Array();
      this.des_articolo_search = null;
      this.cod_articolo_search = null;
      this.dialog_articoli = true;
    },
    salvaModificaElemento() {
      this.elementi_sel
        .filter((elem) => elem.validita == 1)
        .forEach((elem) => {
          const chk_is_new =
            this.items_elementi.filter(
              (e) =>
                e.id_commessa_elemento == elem.id_commessa_elemento &&
                e.validita == 1
            ).length == 0;

          // Se l'elemento è nuovo...
          if (chk_is_new) {
            const elemento_tmp = JSON.parse(JSON.stringify(elem));
            this.items_elementi.push(elemento_tmp);
          } else {
            // Se sto modificando un elemento esistente...
            for (let e = 0; e < this.items_elementi.length; e++) {
              if (
                this.items_elementi[e].id_commessa_elemento ==
                  elem.id_commessa_elemento &&
                this.items_elementi[e].validita == 1
              ) {
                this.$set(this.items_elementi, e, new Elemento(elem));
              }
            }
          }
        });

      this.dialog_edit_elemento = false;
    },
    salvaElementi() {
      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setcommessaelementi",
          token: localStorage.user_token,
          elementi: this.items_elementi.filter(
            (e) => e.validita == 1 || e.id_commessa_elemento > 0
          ),
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.getElementi();
            this.$refs.SnackbarQV.print("success", "Elementi salvati.");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    searchArticoli() {
      if (
        (this.des_articolo_search == null || this.des_articolo_search == "") &&
        (this.cod_articolo_search == null || this.cod_articolo_search == "")
      ) {
        this.$refs.SnackbarQV.print("orange", "Valorizzare almeno un filtro.");
        return;
      }

      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getarticoli",
          token: localStorage.user_token,
          cod_articolo: this.cod_articolo_search,
          des_articolo: this.des_articolo_search,
        },
      };

      this.overlay_articoli = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay_articoli = false;
          if (res.status === 200) {
            if (res.data.lista.length === 0) {
              this.$refs.SnackbarQV.print(
                "orange",
                "Nessun articolo corrisponde ai criteri di ricerca."
              );
            } else {
              this.items_articoli = new Array();
              res.data.lista.forEach((a) => {
                a.selezione = false;
                this.items_articoli.push(a);
              });
            }
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non  stato possibile salvare i dati."
            );
          }
        })
        .catch((err) => {
          this.overlay_articoli = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non  stato possibile salvare i dati."
          );
        });
    },
    selezionaArticoli() {
      if (this.items_articoli.filter((a) => a.selezione == true).length == 0) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Selezionare almeno un articolo.`
        );
        return;
      }

      /* Controllo che non ci siano articoli
       * doppi negli elementi già aggiunti. */
      let des_articolo_tmp = null;
      this.items_articoli
        .filter((a) => a.selezione === true)
        .forEach((a) => {
          this.items_elementi
            .filter((e) => e.validita == 1)
            .forEach((e) => {
              if (e.id_articolo == a.id_articolo) {
                des_articolo_tmp = a.des_articolo;
              }
            });
        });

      /* Controllo che non ci siano articoli
       * doppi negli elementi da aggiungere. */
      this.items_articoli
        .filter((a) => a.selezione === true)
        .forEach((a) => {
          this.elementi_sel
            .filter((e) => e.validita == 1)
            .forEach((e) => {
              if (e.id_articolo == a.id_articolo) {
                des_articolo_tmp = a.des_articolo;
              }
            });
        });

      if (des_articolo_tmp != null) {
        this.$refs.SnackbarQV.print(
          "orange",
          `Elemento già presente: ${des_articolo_tmp}.`
        );
        return;
      }

      /* Se c'è un solo articolo, trasferisco i dati alla
       * finestra di modifica del singolo elemento. */
      if (this.items_articoli.filter((a) => a.selezione == true).length == 1) {
        const articolo_tmp = this.items_articoli.filter(
          (a) => a.selezione == true
        )[0];
        this.$set(
          this.elementi_sel[this.idx_elemento_sel],
          "des_articolo",
          articolo_tmp.des_articolo
        );
        this.$set(
          this.elementi_sel[this.idx_elemento_sel],
          "id_articolo",
          articolo_tmp.id_articolo
        );
        this.dialog_articoli = false;
      } else {
        /* Se ci sono più articoli selezionati li aggiungo
         * in batteria e chiudo tutti i dialog. */
        this.items_articoli
          .filter((a) => a.selezione == true)
          .forEach((a) => {
            console.log("articolo", this.items_elementi.length);
            const obj_tmp = new Elemento(a);
            obj_tmp.id_commessa_elemento = this.assegnaIdCommessaElemento();
            obj_tmp.num_elemento = this.assegnaNumElemento("no_selezionati");
            obj_tmp.id_commessa = this.$route.params.id;
            obj_tmp.num_elemento_display = `E${obj_tmp.num_elemento}`;
            this.items_elementi.push(obj_tmp);
          });
        this.dialog_articoli = false;
        this.dialog_edit_elemento = false;
      }
    },
  },
  created() {},
  mounted() {
    this.getElementi();
  },
};
</script>
<style scoped>
</style>